"use strict";

exports.__esModule = true;
exports.Text = Text;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["block", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Span = _styledComponents["default"].span.withConfig({
  displayName: "Text__Span",
  componentId: "sc-10i92ld-0"
})(["color:", "};"], function (props) {
  return props.muted ? props.theme.MutedTextColor : props.theme.TextColor;
});
var P = _styledComponents["default"].p.withConfig({
  displayName: "Text__P",
  componentId: "sc-10i92ld-1"
})(["color:", "};"], function (props) {
  return props.muted ? props.theme.MutedTextColor : props.theme.TextColor;
});

/**
 * Displays Text.
 */
function Text(_ref) {
  var block = _ref.block,
    children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (block) {
    return /*#__PURE__*/_react["default"].createElement(P, _extends({
      "data-testid": "Text"
    }, extra), children);
  }
  return /*#__PURE__*/_react["default"].createElement(Span, _extends({
    "data-testid": "Text"
  }, extra), children);
}